import * as React from "react";
const SvgFiRrFaceSmileHorns = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-smile-horns_svg__a)">
      <path
        fill="#062147"
        d="M17.746 15.336a1 1 0 0 1-.08 1.41c-.103.091-2.559 2.253-5.666 2.253s-5.563-2.162-5.666-2.254a1 1 0 0 1 1.33-1.493C7.69 15.274 9.672 17 12 17s4.316-1.73 4.336-1.748a1 1 0 0 1 1.41.084m-.348-7.135s-2.794 2.103-2.838 2.138l-.008.006-.002.002A1.49 1.49 0 0 0 14 11.5a1.5 1.5 0 0 0 3 0c0-.154-.03-.3-.074-.439L18.601 9.8a1 1 0 0 0-1.203-1.598M7 11.501a1.5 1.5 0 0 0 3 0 1.49 1.49 0 0 0-.55-1.154q0 0-.003-.002l-.008-.006c-.044-.036-2.838-2.138-2.838-2.138a.999.999 0 1 0-1.203 1.597l1.675 1.262c-.043.14-.073.285-.073.44m17 .5c0 6.616-5.383 12-12 12S0 18.616 0 12c0-1.837.426-3.57 1.166-5.127L.017 1.185a1 1 0 0 1 .366-.97A1 1 0 0 1 1.414.09l4.032 1.871A11.9 11.9 0 0 1 12 .001c2.418 0 4.668.724 6.554 1.96L22.586.09a.999.999 0 0 1 1.396 1.095l-1.149 5.688A11.9 11.9 0 0 1 24 12.001zm-2 0c0-5.515-4.486-10-10-10S2 6.485 2 12c0 5.513 4.486 10 10 10s10-4.487 10-10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-smile-horns_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceSmileHorns;
